import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LucideAngularModule } from 'lucide-angular';
import { CoreDirectivesModule } from '@core/directives/directives';
import { modalLucideIcons } from './modal-icons';
import { ModalWrapperComponent } from './modal-wrapper.component';

@NgModule({
  declarations: [ModalWrapperComponent],
  imports: [
    CommonModule,
    CoreDirectivesModule,
    LucideAngularModule.pick(modalLucideIcons)
  ],
  exports: [ModalWrapperComponent, LucideAngularModule]
})
export class ModalWrapperModule {}
